const ResourceType = {
    SPORTS: 8,
    PICKX: 9,
};
export default ResourceType;